module.exports = __webpack_public_path__ + "static/media/TRIAL 1.f1664e21.mp3";